import React, { useEffect } from "react";

import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import TopBar from "../components/dashboardParts/TopBar";
import { setDocumentTitle } from "system/Utilities";
import { DashboardListContent } from "components/widgets/lists/DashboardList/DashboardList";

export default function ViewOnlyHome(): JSX.Element {
  const { i18n } = useTranslation();

  // Sets document title to default "Infegy Starscape"
  useEffect(() => setDocumentTitle(), []);

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
      <Box sx={{ position: "absolute", top: 0, left: 0, width: "100%", zIndex: 100 }}>
        <TopBar showLogo={true} />
      </Box>

      <Box sx={{ width: "100%", maxWidth: "1000px", mt: 5, mb: 5, p: 2 }}>
        <Typography variant="h3" sx={{ mt:3, mb:1, fontWeight: "600", opacity: 0.8 }}>
          {i18n.t("yourdashboards")}
        </Typography>
        <DashboardListContent />
      </Box>
    </Box>
  );
}